import type { AsyncBelongsTo } from '@ember-data/model';
import { attr, belongsTo } from '@ember-data/model';
import type ActionModel from './action';
import BaseApplyUserModel from './base-apply-user';
import type UserModel from './user';

export default class ApplicationModel extends BaseApplyUserModel {
  @attr('date') declare updatedAt: Date;
  @attr('date') declare createdAt: Date;
  @attr('string') declare ammonReference: string;
  @attr('boolean') declare isValidated: boolean;
  @belongsTo('user', { async: true, inverse: null })
  declare user: AsyncBelongsTo<UserModel>;
  @belongsTo('action', { async: true, inverse: null })
  declare action: AsyncBelongsTo<ActionModel>;
}
